module.exports = __webpack_public_path__ + "media/images/views/lp/recruiter/choose-sourcedout/talent-pool-access-6f0e7507fa908fd606b10b8db89dbacf.png";